import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TIMEOUT } from 'utils/constants';
import TimeoutModal from './TimeoutModal';

// Idle timeout events
const idleTimeoutEvents = [
    'load',
    'mousemove',
    'mousedown',
    'mousewheel',
    'DOMMouseScroll',
    'click',
    'scroll',
    'keypress',
    'keydown',
    'keyup',
    'touchstart'
];

const BaseApp = ({ children }) => {
    const [state, setState] = useState({ time: 0, warningTimer: null });
    const idleTimer = useRef(0);

    useEffect(() => {
        // eslint-disable-next-line no-use-before-define
        setupTimer();
        return () => {
            clearTimeout(idleTimer.current);
        };
        // eslint-disable-next-line no-use-before-define
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idleTimer]);

    const startTimer = useCallback(() => {
        if (state.warningTimer) clearTimeout(state.warningTimer);
        // eslint-disable-next-line no-use-before-define
        idleTimer.current = setTimeout(onIdleTimeout, TIMEOUT.IDLE - TIMEOUT.WARNING);
        // eslint-disable-next-line no-use-before-define
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.warningTimer]);

    const setupTimer = useCallback(() => {
        startTimer();
        idleTimeoutEvents.forEach(ev => {
            window.addEventListener(ev, resetIdleTimer);
        });
        // eslint-disable-next-line no-use-before-define
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTimer]);

    const onIdleTimeout = useCallback(() => {
        // Listen to events, if event occurs, call reset
        idleTimeoutEvents.forEach(ev => {
            window.removeEventListener(ev, resetIdleTimer);
        });
        setState({
            ...state,
            time: TIMEOUT.WARNING / 1000,
            warningTimer: setTimeout(() => {
                // resetState();
                // Would rather use react-router history here but doesn't seem to work
                window.location.replace(process.env.PUBLIC_URL + '/timeout');
            }, TIMEOUT.WARNING)
        });
        // eslint-disable-next-line no-use-before-define
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    const resetIdleTimer = useCallback(() => {
        clearTimeout(idleTimer.current);
        startTimer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTimer]);

    const stayLoggedIn = () => {
        setupTimer();
        clearTimeout(idleTimer.current);
        setState({ ...state, time: 0 });
    };

    return (
        <div>
            <TimeoutModal time={state.time} reset={stayLoggedIn} />
            {children}
        </div>
    );
};

export default BaseApp;
